var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.417 35q-1 0-1.709-.708Q5 33.583 5 32.583V15.75q0-1 .708-1.708.709-.709 1.709-.709h9.458V6.417q0-.584.417-1 .416-.417 1-.417h3.416q.625 0 1.021.417.396.416.396 1v6.916h9.458q1 0 1.709.709.708.708.708 1.708v16.833q0 1-.708 1.709-.709.708-1.709.708Zm0-1.417h25.166q.417 0 .709-.291.291-.292.291-.709V15.75q0-.417-.291-.708-.292-.292-.709-.292h-9.458q0 .833-.479 1.125-.479.292-1.313.292h-2.666q-.834 0-1.313-.292t-.479-1.125H7.417q-.417 0-.709.292-.291.291-.291.708v16.833q0 .417.291.709.292.291.709.291Zm3-4.625h8.958v-.208q0-.583-.313-1.062-.312-.48-.812-.688-.958-.375-1.75-.521-.792-.146-1.583-.146-.792 0-1.625.167-.834.167-1.75.5-.5.208-.813.688-.312.479-.312 1.062Zm13-2.666h6.791v-1.334h-6.791Zm-8.5-1.334q.791 0 1.354-.562.562-.563.562-1.354 0-.792-.562-1.354-.563-.563-1.354-.563-.75 0-1.334.563Q13 22.25 13 23.042q0 .791.583 1.354.584.562 1.334.562Zm8.5-2.541h6.791v-1.334h-6.791Zm-5.125-7.667h3.416V6.417h-3.416ZM20 24.167Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.54d302626f438884d3b063b394ebe35c.svg";
export { ForwardRef as ReactComponent };